import React from 'react'

import Layout from '../components/layout'

const VolunteerApplicationPage = () => (
  <Layout>
    <article className="pa4 black-80">
        <form name="volunteer" action="volunteer-success" accept-charset="utf-8" netlify-honeypot="honeypot"  data-netlify="true">
            <h1 className="f2 lh-title fw9 mb3 mt0 pt3 bt bw2">
                Volunteer Application
            </h1>
            <input type="hidden" name="form-name" value="volunteer" />
            <fieldset id="volunteer" className="ba b--transparent ph0 mh0">
                <div className="hidden">
                    <label>Don’t fill this out if you're human: <input name="honeypot" /></label>
                </div>
                <div className="fl w-50 pa2">
                    <div className="measure">
                        <label for="name" className="f6 b db mb2">Name </label>
                        <input id="name" name="name" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" aria-describedby="name-desc" required />
                    </div>
                    <div className="measure">
                        <label for="email" className="f6 b db mb2">Email </label>
                        <input id="email" name="email" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="email" aria-describedby="address-desc" required />
                        {/* <small id="address-desc" className="f6 black-60 db mb2">Helper text for the form control.</small> */}
                    </div>
                    <div className="measure">
                        <label for="number" className="f6 b db mb2">Phone Number</label>
                        <input id="number" name="number" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="tel" aria-describedby="number-desc" required />
                        {/* <small id="number-desc" className="f6 black-60 db mb2">A contact number where we can reach you.</small> */}
                    </div>
                    <div className="measure">
                        <label for="experience" className="f6 b db mb2">Previous Experience </label>
                        <textarea id="experience" name="experience" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="experience" aria-describedby="experience-desc" required />
                        {/* <small id="email-desc" className="f6 black-60 db mb2">Your contact email address.</small> */}
                    </div>
                    <div className="measure">
                        <label for="referee" className="f6 b db mb2">Referee Contact Details (At least 2) </label>
                        <textarea id="referee" name="referee" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="referee" aria-describedby="referee-desc" required />
                        {/* <small id="artwork-desc" className="f6 black-60 db mb2">The name of your artwork.</small> */}
                    </div>
                </div>
                <div className="fl w-50 pa2">
                    
                    <div className="measure">
                        <label for="medium" className="f6 b db mb2">Please list any dates or times you are unavaialble </label>
                        <textarea id="unavailable" name="unavailable" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="unavailable" aria-describedby="unavailable-desc" required />
                        {/* <small id="medium-desc" className="f6 black-60 db mb2">The medium used in creating your artwork.</small> */}
                    </div>
                    <div className="measure">
                        <legend className="fw7 mb2">I am Available</legend>
                        <div className="available-container">
                            <div className="flex items-center mb2 available-box">
                                <input className="mr2" name="available" type="checkbox" id="wednesday11" value="Wednesday 11-1.30pm" />
                                <label for="spacejam" className="lh-copy">Wednesday 11-1.30pm</label>
                            </div>
                            <div className="flex items-center mb2 available-box">
                                <input className="mr2" name="available" type="checkbox" id="wednesday130" value="Wednesday 1.30-4pm" />
                                <label for="airbud" className="lh-copy">Wednesday 1.30-4pm</label>
                            </div>
                            <div className="flex items-center mb2 available-box">
                                <input className="mr2" name="available" type="checkbox" id="thursday11" value="Wednesday 11-1.30pm" />
                                <label for="spacejam" className="lh-copy">Thursday 11-1.30pm</label>
                            </div>
                            <div className="flex items-center mb2 available-box">
                                <input className="mr2" name="available" type="checkbox" id="thursday130" value="Wednesday 1.30-4pm" />
                                <label for="airbud" className="lh-copy">Thursday 1.30-4pm</label>
                            </div>
                            <div className="flex items-center mb2 available-box">
                                <input className="mr2" name="available" type="checkbox" id="saturday11" value="Wednesday 11-1.30pm" />
                                <label for="spacejam" className="lh-copy">Saturday 11-1.30pm</label>
                            </div>
                            <div className="flex items-center mb2 available-box">
                                <input className="mr2" name="available" type="checkbox" id="saturday130" value="Wednesday 1.30-4pm" />
                                <label for="airbud" className="lh-copy">Saturday 1.30-4pm</label>
                            </div>
                            <div className="flex items-center mb2 available-box">
                                <input className="mr2" name="available" type="checkbox" id="sunday11" value="Wednesday 11-1.30pm" />
                                <label for="spacejam" className="lh-copy">Sunday 11-1.30pm</label>
                            </div>
                            <div className="flex items-center mb2 available-box">
                                <input className="mr2" type="checkbox" id="sunday130" value="Wednesday 1.30-4pm" />
                                <label for="airbud" className="lh-copy">Sunday 1.30-4pm</label>
                            </div>
                        </div>
                    </div>
                    <div className="measure" data-netlify-recaptcha="true"></div>
                </div>
            </fieldset>
            <div className="tc mt1 pa2 fl w-100">
                <button className="b ph3 pv2 input-reset ba b--black bg-transparent grow pointer f6" type="submit">Submit</button>
            </div>
        </form>
    </article>
  </Layout>
)

export default VolunteerApplicationPage
